export type Route = {
    path: string;
    component: () => Promise<any>;
};

export const routes: Route[] = [
    {
        path: '/',
        component: () => import('@/components/pages/home/home.ts'),
    },
    {
        path: '/login',
        component: () => import('@/components/pages/login/login.ts'),
    },
    {
        path: '/or/list',
        component: () => import('@/components/pages/work-orders/work-order-list/work-order-list'),
    },
    {
        path: '/or/me',
        component: () => import('@/components/pages/work-orders/work-order-list/work-order-list'),
    },
    {
        path: '/or/new',
        component: () => import('@/components/pages/work-orders/work-order-new/work-order-new'),
    },
    {
        path: '/or/:or/details',
        component: () => import('@/components/pages/work-orders/work-order-edit/work-order-edit'),
    },
    {
        path: '/potencial/list',
        component: () => import('@/components/pages/presales/presale-list/presale-list.ts'),
    },
    {
        path: '/potencial/form/:pre?',
        component: () => import('@/components/pages/presales/presale-form/presale-form'),
    },
    {
        path: '/mec-selection',
        component: () => import('@/components/pages/time-control/time-control-sign-in/time-control-sign-in.ts'),
    },
    {
        path: '/taller/marcaje',
        component: () => import('@/components/pages/time-control/time-control-edit/time-control-edit.ts'),
    },
    {
        path: '/taller/recepcion',
        component: () => import('@/components/pages/vehicle-reception/vehicle-selection/vehicle-selection.ts'),
    },
    {
        path: '/taller/recepcion/new-or',
        component: () =>
            import('@/components/pages/vehicle-reception/vehicle-reception-new-or/vehicle-reception-new-or.ts'),
    },
    {
        path: '/isisign',
        component: () => import('@/components/pages/isisign/isisign.ts'),
    },
    {
        path: 'notfound',
        component: () => import('@/components/pages/404/404.ts'),
    },
];

export const redirects: { from: string; to: string }[] = [
    { from: '/presunto/new', to: '/potencial/form' },
    { from: '/presunto/modify', to: '/potencial/list' },
];
